<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {};
  },
  mounted() {
    let _this = this;
    window.onresize = () => {
      _this.$store.commit("windowResize", {
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight,
      });
    };

    // WebSocket 连接
    this.connectWebSocket();

    // 初始化设备列表
    if (!localStorage.getItem("devicelist")) {
      localStorage.setItem(
        "devicelist",
        '["产品图","产品型号","设备ID","状态","SN","操作"]'
      );
    }
  },
  watch: {
    $route({ path }) {
      sessionStorage.setItem("currPath", path);
    },
  },
  created() {
    let loading = document.getElementById("loadigArea");
    if (loading) {
      loading.remove();
    }
  },
  methods: {
    connectWebSocket() {
      // 替换为你的 WebSocket 服务器 URL
      const socket = new WebSocket("ws://your-websocket-server-url");

      socket.onopen = () => {
        console.log("WebSocket 连接已建立。");
      };

      socket.onmessage = (event) => {
        console.log("收到消息:", event.data); // 打印收到的消息
        _this.$store.commit("setWebsocketData", event.data);
      };

      socket.onerror = (event) => {
        console.error("WebSocket 发生错误:", event);
      };

      socket.onclose = () => {
        console.log("WebSocket 连接已关闭。");
      };
    },
  },
};
</script>

<style lang="less">
.size {
  width: 100%;
  height: 100%;
}
html,
body {
  .size;
  margin: 0;
  padding: 0;
}
body {
  min-width: 1250px;
  height: 100%;
  min-height: 600px;
}
#app {
  .size;
}
::-webkit-scrollbar {
  width: 0.5rem;
  height: 0.5rem;
  background: hsla(0, 0%, 100%, 0.6);
}

::-webkit-scrollbar-track {
  border-radius: 0;
}

::-webkit-scrollbar-thumb {
  border-radius: 0;
  background-color: rgba(95, 95, 95, 0.4);
  transition: all 0.2s;
  border-radius: 0.5rem;
}
::-webkit-scrollbar-thumb:hover {
  background-color: rgba(95, 95, 95, 0.7);
}
.contentBaseRef {
  width: 100%;
}
</style>
